module.exports = __webpack_public_path__ + "static/media/ic-2.2394cd08.svg";